export * from "./list-update.resolver";
export * from "./list-update.component";
